module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_17.48e97a7d.mp3";